import type { Ref } from "vue";
import { computed, ref, watch } from "vue";

import { useActionMenu } from "@/components/ActionMenu/useActionMenu";
import { useModalStore } from "@/store/modal";

export function useSelectionActionMenu(
  rect: Ref<Element | null>,
  open: Ref<boolean>,
  attrs: Ref<unknown>,
) {
  const menu = useActionMenu({
    referenceEl: rect,
    open,
    disabled: ref(false),
    config: computed(() => ({ placement: "top", offset: [0, 5] })),
  });

  const modalStore = useModalStore();

  watch(attrs, menu.updateMenu, { deep: true });

  // Update menu position when modal state changes. We need to do this because when the
  // modal is opened, the browser adds scrollbars to the body, which changes the position of
  // the menu.
  watch(() => modalStore.isModalOpen(), menu.updateMenu);

  return menu;
}
